import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import { useShowAttendees } from "./hooks";
import AttendeesTabs from "./attendees-tabs";
import TambolaTickets from "../tambola-tickets";

const ShowAttendees = ({ eventScheduleId, bookedInfo }) => {
  const {
    attendeesList,
    toggleModal,
    isOpenModal,
    openAttendeesList,
    downloadAttendeesList,
    showTicket,
    handleShowTicket,
    handleTicket,
    tickets,
  } = useShowAttendees(eventScheduleId);

  return (
    <div>
      <Tooltip title="Click to view Attendees." placement="bottom">
        <span
          className="schedule__booked-info"
          onClick={() => openAttendeesList()}
        >
          {bookedInfo}
        </span>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <AttendeesTabs
              tabs={["booked", "attended"]}
              tabsData={attendeesList}
              handleTicket={handleTicket}
            />
          }
          title="Attendees"
          isDownloadFile={true}
          downloadFile={downloadAttendeesList}
        />
      ) : null}
      {showTicket ? (
        <Modals
          isOpenModal={showTicket}
          setIsOpenModal={handleShowTicket}
          title="Tambola Tickets"
          message={<TambolaTickets tickets={tickets} />}
        />
      ) : null}
    </div>
  );
};

export default ShowAttendees;
